import React from 'react'
import { Link } from 'react-router-dom'

import { contactUsRoute } from '../../routes/routes'

const ThankYou = props => (
  <div className="container">
    <div className="row">
      <div className="col center">
        <h2 className="primary">Thank you!</h2>
      </div>
    </div>
    <div className="row  pb-15">
      <div className="col center">
        We have received your request. A Foodsby representative will get back to
        you shortly.
      </div>
    </div>
    <div className="row">
      <div className="col center">
        <Link to={contactUsRoute.path}>
          <button className="primary">Go Back</button>
        </Link>
      </div>
    </div>
  </div>
)

export default ThankYou
